import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';  // Import useLocation
import { Drawer, List, ListItem, ListItemButton, ListItemIcon, Typography, IconButton } from '@mui/material';
import { Home, Star, Image, Menu, X } from 'lucide-react'; // Use lucide-react for icons
import { Outlet } from 'react-router-dom';  // Import Outlet

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // Hook to get current location

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const handleNavigation = (path) => {
    navigate(path); // This should navigate to the path when clicked
  };

  const menuItems = [
    { name: 'Dashboard', icon: <Home size={20} />, path: '/admin' },
    { name: 'ReviewMaster', icon: <Star size={20} />, path: '/admin/reviewmaster' },
    { name: 'GalleryMaster', icon: <Image size={20} />, path: '/admin/gallerymaster' },
  ];

  return (
    <div style={{ display: 'flex' }}>
      {/* Sidebar Drawer */}
      <Drawer
        variant="persistent"
        open
        sx={{
          width: collapsed ? 80 : 240,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: collapsed ? 80 : 240,
            backgroundColor: '#333',
            color: 'white',
            transition: 'width 0.3s',
          },
        }}
      >
        {/* Sidebar header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          {!collapsed && (
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'white' }}>
              App Name
            </Typography>
          )}
          <IconButton onClick={toggleSidebar} sx={{ color: 'white' }}>
            {collapsed ? <Menu size={20} /> : <X size={20} />}
          </IconButton>
        </div>

        {/* Sidebar menu */}
        <List>
          {menuItems.map((item, index) => (
            <ListItem key={index} disablePadding>
              <ListItemButton
                onClick={() => handleNavigation(item.path)} // Correct navigation
                sx={{
                  backgroundColor: location.pathname.startsWith(item.path) ? 'rgba(0, 0, 255, 0.2)' : 'transparent',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 255, 0.1)',
                  },
                }}
              >
                <ListItemIcon sx={{ color: 'white' }}>{item.icon}</ListItemIcon>
                {!collapsed && (
                  <Typography variant="body1" sx={{ color: 'white' }}>
                    {item.name}
                  </Typography>
                )}
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        {/* User profile at bottom */}
        <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
          <div className="flex items-center p-4 border-t border-gray-700">
            <div className="w-10 h-10 rounded-full bg-gray-400 flex-shrink-0"></div>
            {!collapsed && (
              <div className="ml-3">
                <Typography variant="body2" sx={{ color: 'white' }}>
                  User Name
                </Typography>
                <Typography variant="caption" sx={{ color: 'gray' }}>
                  user@example.com
                </Typography>
              </div>
            )}
          </div>
        </div>
      </Drawer>

      {/* Main content with Outlet for nested routes */}
      <div style={{ flexGrow: 1, padding: '20px' }}>
        <Outlet />
      </div>
    </div>
  );
};

export default Sidebar;
